import { format, startOfDay, startOfMonth } from 'date-fns';

import type { FiltroPorPeriodoValue } from '../components/FiltroPorPeriodo';
import { todayOfficialDateKey, addOfficialDaysISO } from './officialDate';

/**
 * Período padrão PA/PV ao abrir telas: **ESTE MÊS** (1º do mês → hoje).
 * Use sempre que inicializar ou resetar filtros de data no front.
 */
export function getDefaultPeriodRange(): FiltroPorPeriodoValue {
  const end = startOfDay(new Date());
  const start = startOfMonth(end);
  return {
    start: format(start, 'yyyy-MM-dd'),
    end: format(end, 'yyyy-MM-dd'),
    preset: 'este_mes',
  };
}

/** @deprecated Prefer `getDefaultPeriodRange` (padrão PA/PV: este mês). */
export function getDefaultLast30DaysRange(): FiltroPorPeriodoValue {
  return getDefaultPeriodRange();
}

/**
 * Converte valor do filtro para parâmetros de API (publicação).
 * TOTAL usa a 1ª data gravada quando disponível (evita resposta vazia nos gráficos).
 */
export function periodToApiRange(
  value: FiltroPorPeriodoValue,
  publicationDateMin?: string | null,
): { start: string | null; end: string | null } {
  if (value.preset === 'total' || (!value.start && !value.end)) {
    if (publicationDateMin) {
      return { start: publicationDateMin, end: todayOfficialDateKey() };
    }
    return { start: null, end: null };
  }
  return { start: value.start ?? null, end: value.end ?? null };
}

/**
 * Limite superior do eixo do gráfico de timeline (só exibição).
 * Períodos em curso ou futuros terminam em D+1; intervalos 100% passados mantêm o fim do filtro.
 */
export function chartTimelineRangeEnd(apiEnd: string | null | undefined): string {
  const today = todayOfficialDateKey();
  const dPlusOne = addOfficialDaysISO(today, 1);
  if (!apiEnd || apiEnd >= today) return dPlusOne;
  return apiEnd;
}
